function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1007.4,2H1.6l464.9,464.9V1008h76V466.9L1007.4,2z M823.9,78L504.5,397.4L185.1,78H823.9z"
})));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1010 1010"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/filter-ep.75b68a67.svg";
export { SvgComponent as ReactComponent };